import React from 'react';

import QuestHero from '../components/quest/index'

const WaitlistPage = () => {
  return (
    <div className="waitlist-page">
     <QuestHero />
    </div>
  );
};

export default WaitlistPage;